module.exports = __webpack_public_path__ + "img/security1.f9ef8c7e.png";